// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__1UdaD","bgImage":"home_bgImage__1eo-i"};